import {
  InvoiceResponse,
  InvoiceStatsResponse,
  InvoiceType,
  PagedResponse,
} from "../types/invoice.definition";
import {
  getAllInvoices,
  getInvoicesDue,
  getInvoiceStats,
  getPendingInvoiceForFacility,
  sendInvoice,
} from "../webclients/invoice.client";

/** `type` scopes a call to FACILITY or DOCTOR invoices; without it both are returned. */
export const invoiceApi = {
  getAll: async (
    page = 0,
    size = 10,
    status?: string,
    type?: InvoiceType
  ): Promise<PagedResponse<InvoiceResponse>> => {
    const response = await getAllInvoices(page, size, status, type);
    return response.data;
  },

  getDue: async (
    year: number,
    month: number,
    page = 0,
    size = 10,
    type?: InvoiceType
  ): Promise<PagedResponse<InvoiceResponse>> => {
    const response = await getInvoicesDue(year, month, page, size, type);
    return response.data;
  },

  getStats: async (
    year: number,
    month: number,
    type?: InvoiceType
  ): Promise<InvoiceStatsResponse> => {
    const response = await getInvoiceStats(year, month, type);
    return response.data;
  },

  /**
   * MED-1471: the facility's outstanding invoice. Rejects with INVOICE_NOT_FOUND when
   * there is none (a TRIAL licence owes nothing, for instance).
   */
  getPendingForFacility: async (
    facilityId: number
  ): Promise<InvoiceResponse> => {
    const response = await getPendingInvoiceForFacility(facilityId);
    return response.data;
  },

  /** MED-1471: rejects with INVALID_PARAMETER when the invoice has no e-mail recipient. */
  send: async (invoiceId: number): Promise<InvoiceResponse> => {
    const response = await sendInvoice(invoiceId);
    return response.data;
  },
};
